'use client';
import React, { useEffect, useRef, useState } from 'react';
import get from 'lodash/get';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
function DocumentAutoScroll({ posstDocumentType, websiteCode }) {
  const trackRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;
    let x = 0;
    let raf;

    const tick = () => {
      if (!isHovering) {
        x -= 1;
        if (Math.abs(x) >= el.scrollWidth / 2) x = 0;
        el.style.transform = `translateX(${x}px)`;
      }
      raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [isHovering]);

  const items = posstDocumentType ?? [];

  const renderItems = () =>
    items.map((doc, index) => (
      <React.Fragment key={index}>
        <Link
          href={websiteCode ? `/sub/${websiteCode}/van-ban/${doc?.slug}` : `/van-ban/${doc?.slug}`}
          className="text-[13.5px] text-gray-700 hover:text-[#b71c1c] transition-colors duration-200 whitespace-nowrap"
          dangerouslySetInnerHTML={{ __html: doc?.title ?? '' }}
        />
        <span className="text-gray-300 mx-3 select-none">|</span>
      </React.Fragment>
    ));

  return (
    <div className="overflow-hidden flex-1 px-4" onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
      <div ref={trackRef} className="flex items-center will-change-transform">
        {renderItems()}
        {renderItems()}
      </div>
    </div>
  );
}
const NewText = ({ newTexts, websiteCode }) => {
  const t = useTranslations('');
  const items = get(newTexts, 'results', []);
  return (
    <div className="flex items-center bg-white rounded shadow-sm border-l-4 border-[#b71c1c] overflow-hidden mb-6">
      <div className="bg-[#b71c1c] text-white px-4 py-3 flex items-center gap-2 shrink-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
        <span className="text-[13px] font-bold uppercase tracking-wide whitespace-nowrap">{t('home.newDocument')}</span>
      </div>
      <DocumentAutoScroll posstDocumentType={items} websiteCode={websiteCode} />
    </div>
  );
};

export default NewText;
